import React from "react";
import styles from "./terms.module.scss";
import { Heading, Link, Text } from "@radix-ui/themes";

const TermsAndConditions: React.FC = () => (
  <div className={`container ${styles.termsContainer}`}>
    <Heading as="h1" color="blue">
      Terms and Conditions
    </Heading>
    <Text as="p">
      Most states have released their own guidelines for inbound and outbound
      travellers vis-a-vis passes, permits, quarantine rules and other
      requirements. Please go through the guidelines of your source and
      destination state carefully before planning your travel.
    </Text>
    <Heading as="h2" size="4">
      TERMS OF SERVICE
    </Heading>
    <ol>
      <li>
        <Heading as="h3" size="3">
          BUS Booking Service
        </Heading>
        <ol>
          <li>
            <Heading as="h4" size="2">
              ROLE OF{" "}
              <Link href="https://quickbusride.com">
                <strong>QuickBusRide</strong>
              </Link>
            </Heading>
            <Text as="p">
              <Link href="https://quickbusride.com">
                <strong>QuickBusRide</strong>
              </Link>{" "}
              only provides a technology platform that connects intending
              travelers with bus operators. It doesn't operate any bus or offer
              the service of transportation to the User.{" "}
              <Link href="https://quickbusride.com">
                <strong>QuickBusRide</strong>
              </Link>{" "}
              also doesn't act as an agent of any bus operator in the process of
              providing the above-mentioned technology platform services.
            </Text>
          </li>
          <li>
            <Heading as="h4" size="2">
              LIMITATION OF LIABILITY OF{" "}
              <Link href="https://quickbusride.com">
                <strong>QuickBusRide</strong>
              </Link>
            </Heading>
            <Text as="p">
              In its role as a technology platform to enable transactions
              between the bus operators and the Users,{" "}
              <Link href="https://quickbusride.com">
                <strong>QuickBusRide</strong>
              </Link>{" "}
              shall not be responsible for the operations of the bus operator
              including, but not limited to the following:
            </Text>
            <ol>
              <li>
                <Text as="p">Timely departure or arrival of the bus;</Text>
              </li>
              <li>
                <Text as="p">
                  The conduct of bus operator's employees, representatives or
                  agents;
                </Text>
              </li>
              <li>
                <Text as="p">
                  The condition of the bus, seats etc. not being up to the
                  customer's expectation or as per the description provided by
                  the bus operator;
                </Text>
              </li>
              <li>
                <Text as="p">Cancellation of the trip due to any reasons;</Text>
              </li>
              <li>
                <Text as="p">
                  Loss or damage of the baggage of the customer;
                </Text>
              </li>
              <li>
                <Text as="p">
                  The bus operator changing a customer's seat for any reason
                  whatsoever;
                </Text>
              </li>
              <li>
                <Text as="p">
                  Bus operator informing a wrong boarding point for the issuance
                  of the booking confirmation voucher, or changing such boarding
                  point eventually with or without any notification to {" "}
                  <Link href="https://quickbusride.com">
                    <strong>QuickBusRide</strong>
                  </Link>{" "}
                  or the User;
                </Text>
              </li>
              <li>
                <Text as="p">
                  Bus operator using a separate pick-up vehicle to transport the
                  User from the designated boarding point to the actual place of
                  departure of the bus.
                </Text>
              </li>
            </ol>
          </li>
          <li>
            <Heading as="h4" size="2">
              RESPONSIBILITIES OF THE USERS
            </Heading>
            <ol>
              <li>
                <Text as="p">
                  Users are advised to call the bus operator to find out the
                  exact boarding point, or any information which they may need
                  for the purpose of boarding or travel in that trip.
                </Text>
              </li>
              <li>
                <Text as="p">
                  At the time of boarding the bus, Users shall furnish a copy of
                  the ticket, and any valid identity proof like aadhar card,
                  passport, PAN card or voter identification card or any other
                  identity proof issued by a government authority.
                </Text>
              </li>
              <li>
                <Text as="p">
                  Users are required to reach the boarding place at least 30
                  minutes before the scheduled departure time.
                </Text>
              </li>
              <li>
                <Text as="p">
                  All tickets issued shall be non-transferable.
                </Text>
              </li>
            </ol>
          </li>
          <li>
            <Heading as="h4" size="2">
              CANCELLATION OF TICKET
            </Heading>
            <ol>
              <li>
                <Text as="p">
                  Cancellation of tickets can be done either through the User's
                  login in the{" "}
                  <Link href="https://quickbusride.com">
                    <strong>QuickBusRide</strong>
                  </Link>{" "}
                  website, Or by sending mail in case any issue with website
                </Text>
              </li>
              <li>
                <Text as="p">
                  Any cancellation is subject to such cancellation charges as
                  mentioned on the ticket.
                </Text>
              </li>
            </ol>
          </li>
          <li>
            <Heading as="h4" size="2">
              RESCHEDULING OF TICKET
            </Heading>
            <ol>
              <li>
                <Text as="p">
                  Rescheduling is not permitted. In case its required user has
                  to cancel the existing ticket and book a new one on the
                  desired date.
                </Text>
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
  </div>
);

export default TermsAndConditions;
